import React from 'react';
import { Globe, Sparkles } from 'lucide-react';
import SubjectPageLayout from '../components/SubjectPageLayout';
import SitesIA from '../components/SitesIA';

const SCHEMA = {
  "@type": "Service",
  "serviceType": "Criação de sites e presença digital com IA",
  "provider": { "@type": "LocalBusiness", "name": "Fernando Tech", "areaServed": "Ribeirão Preto e região" },
  "description": "Criação de sites profissionais, landing pages e presença digital com inteligência artificial, otimizados para SEO e conversão.",
};

const FAQ = [
  { q: "A Fernando Tech cria sites profissionais?", a: "Sim. Criamos sites, landing pages e lojas usando tecnologia moderna e inteligência artificial." },
  { q: "Os sites são otimizados para o Google (SEO)?", a: "Sim. Entregamos sites rápidos e otimizados para SEO, ajudando você a aparecer nas buscas." },
  { q: "O site funciona no celular?", a: "Sim. Todos os sites são responsivos e se adaptam a celulares, tablets e computadores." },
  { q: "Vocês cuidam do domínio e da hospedagem?", a: "Sim. Oferecemos registro de domínio e hospedagem, cuidando de tudo para você." },
  { q: "Quanto tempo leva para criar um site?", a: "Depende do projeto, mas sites institucionais costumam ficar prontos em poucos dias. Fale conosco para um prazo exato." },
];

export default function SitesPage() {
  return (
    <SubjectPageLayout
      path="/sites"
      breadcrumbName="Sites & IA"
      breadcrumbIcon={<Globe className="w-3.5 h-3.5" />}
      seoTitle="Criação de Sites com IA | Fernando Tech — Ribeirão Preto"
      seoDescription="Criação de sites profissionais e landing pages com inteligência artificial pela Fernando Tech: design moderno, otimização para SEO, velocidade e foco em conversão. Atendimento em Ribeirão Preto e região."
      extraSchema={SCHEMA}
      faq={FAQ}
      hero={{
        badge: 'Sites com Inteligência Artificial',
        badgeIcon: <Sparkles className="w-3.5 h-3.5" />,
        title: 'Sites & IA',
        accent: 'presença digital que converte',
        subtitle: 'Sites profissionais e landing pages criados com IA — design moderno, rápidos, otimizados para SEO e prontos para gerar clientes.',
      }}
      cta={{ heading: 'Quer um site profissional para o seu negócio?', text: 'Fale com a Fernando Tech e coloque a sua empresa na internet com um site rápido, bonito e otimizado.' }}
    >
      <SitesIA />
    </SubjectPageLayout>
  );
}
